export class ApprovedPaymentModel {
    paymentDate: Date|string = new Date()

    constructor(a?: Partial<ApprovedPaymentModel>) {
        Object.assign(this, a)
    }

    isValid():boolean {
        return !!this.paymentDate
    }
}
